module.exports = __webpack_public_path__ + "static/media/ZillaSlab-LightItalic.07c607e8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-LightItalic.ttf
// module id = 3758
// module chunks = 71